import React, { useState } from "react";
import { Field, Form } from "react-final-form";
import InfoIcon from "@material-ui/icons/InfoOutlined";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import { useAccountSectionUnlocking } from "features/Account/utils/useAccountSectionChange";
import ExlyRadioGroup from "common/form/ExlyRadioGroup/Index";
import {
  GRACE_PERIOD_APPLICABILTITY_KEYS,
  GRACE_PERIOD_APPLICABILTITY_OPTIONS,
} from "features/Account/modules/Features/constants/Features.constants";
import api from "data/APIs";
import { FEEDBACK_SETTINGS_KEY } from "../constants/ExlyFeedback.constants";
import { OutlinedInput } from "@material-ui/core";

export const ExlyFeedbackGracePeriodModal = ({ baseValue, onClose }) => {
  const { handleSectionChange } = useAccountSectionUnlocking();

  const [days, setDays] = useState(1);
  const [applicability, setApplicability] = useState(
    GRACE_PERIOD_APPLICABILTITY_KEYS.NEW_LISTING
  );

  const handleSubmit = () => {
    handleSectionChange({
      endPoint: api.feedbacks.disable_customer_feedback,
      payload: {
        feature_key: FEEDBACK_SETTINGS_KEY,
        feature_value: baseValue,
        grace_period_days: days,
        grace_period_applicability: applicability,
      },
    });

    onClose();
  };

  return (
    <Form
      onSubmit={handleSubmit}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <ExlyModal
            title="Please confirm changes"
            open
            onClose={onClose}
            modal_props={{
              footerClassName: "!tw-justify-between",
              secondaryBtnClassName: "!tw-text-[#493ab1] !tw-min-w-[unset]",
            }}
            primaryBtnText="Save changes"
            onPrimaryBtnClick={handleSubmit}
            showSecondaryBtn
            onSecondaryBtnClick={onClose}
            className="!tw-p-0"
          >
            <div className="tw-flex tw-items-center tw-bg-[#E5F0FF] tw-leading-[14.32px] tw-p-[15px] tw-rounded-[4px] tw-text-black tw-w-full">
              <InfoIcon className="tw-h-[20px] tw-mr-1 !tw-text-[18px]" />
              <span className="tw-text-[14px] tw-ml-[4px]">
                These changes affect customised offerings.
              </span>
            </div>

            <div className="tw-px-[36px] tw-pt-[18px] tw-pb-[16px]">
              <div className="mb-2 tw-text-[#272522] tw-font-medium tw-leading-normal tw-tracking-[0.28px]">
                Number of days grace period to apply
              </div>
              <span className="tw-flex tw-items-center">
                <OutlinedInput
                  value={days}
                  onChange={(e) => setDays(e.target.value)}
                  size="small"
                />
              </span>
            </div>

            <div className="tw-px-[36px] tw-pb-[24px]">
              <div className="mb-3 tw-text-[#272522] tw-font-medium tw-leading-normal tw-tracking-[0.28px]">
                Would you like to apply these updates to all existing offerings
                as well, or just to new ones?
              </div>
              <Field
                name="type"
                component={ExlyRadioGroup}
                options={GRACE_PERIOD_APPLICABILTITY_OPTIONS}
                value={applicability}
                onChange={setApplicability}
              />
            </div>
          </ExlyModal>
        </form>
      )}
    />
  );
};
